import { User } from "../../shared/lib/types/Types";

export enum AuthActionTypes {
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT'
}

interface LoginAction {
    type: AuthActionTypes.LOGIN,
    payload: User
}

interface LogoutAction {
    type: AuthActionTypes.LOGOUT
}

export type AuthActions = LoginAction | LogoutAction;